import React from "react";
import { formatDate, formatEdition } from "../utils/licenceUtils";

function Pagination({ page, totalPages, onGoToPage }) {
  return (
    <div className="flex items-center justify-center px-6 py-3 border-t border-[#3D3935] text-xs text-gray-700">
      <div className="flex items-center gap-1">
        <button
          onClick={() => onGoToPage(page - 1)}
          disabled={page === 1}
          className="px-3 py-1 rounded disabled:opacity-40 disabled:cursor-default hover:bg-gray-100 transition"
        >
          {"<"}
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
          <button
            key={p}
            onClick={() => onGoToPage(p)}
            className={
              "px-3 py-1 rounded text-xs " +
              (p === page ? "bg-[#ffbf3c] text-white" : "bg-white hover:bg-gray-100")
            }
          >
            {p}
          </button>
        ))}

        <button
          onClick={() => onGoToPage(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-1 rounded disabled:opacity-40 disabled:cursor-default hover:bg-gray-100 transition"
        >
          {">"}
        </button>
      </div>
    </div>
  );
}

export default function LicencesTable({ pageItems, page, totalPages, onGoToPage, renewingKey, onRenew }) {
  if (pageItems.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[300px] text-[#3D3935] gap-3">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.3">
          <rect x="2" y="7" width="20" height="14" rx="2" />
          <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        </svg>
        <p className="text-[14px] font-medium opacity-50">No licences found</p>
      </div>
    );
  }

  return (
    <table className="min-w-full text-sm text-left text-gray-700 bg-transparent">
      <thead className="font-semibold text-gray-700 border-b border-[#3D3935]">
        <tr>
          <th className="px-2 py-3 md:px-6">License Key</th>
          <th className="px-2 py-3 md:px-6">ResellerID</th>
          <th className="px-2 py-3 md:px-6">Edition</th>
          <th className="px-2 py-3 md:px-6">Type</th>
          <th className="px-2 py-3 md:px-6">Expiry Date</th>
          <th className="px-2 py-3 md:px-6 md:text-center">Action</th>
        </tr>
      </thead>

      <tbody>
        {pageItems.map((licence) => (
          <tr
            key={licence.LicenseKey}
            className="border-b border-[#3D3935] last:border-b-0"
          >
            <td className="px-2 py-4 md:px-6">
              <span className="inline-block w-2.5 h-2.5 bg-red-500 rounded-full mr-1.5" />
              {licence.LicenseKey}
            </td>
            <td className="px-2 py-4 md:px-6">{licence.ResellerID}</td>
            <td className="px-2 py-4 md:px-6">{formatEdition(licence.Edition)}</td>
            <td className="px-2 py-4 md:px-6">{licence.Type}</td>
            <td className="px-2 py-4 md:px-6">{formatDate(licence.ExpiryDate)}</td>
            <td className="px-2 py-4 md:px-6 md:text-center">
              <button
                onClick={() => onRenew(licence)}
                disabled={renewingKey === licence.LicenseKey}
                className="px-4 py-2 text-xs font-medium bg-white text-[#3D3935] rounded-lg hover:bg-[#ffbf3c] hover:text-white transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {renewingKey === licence.LicenseKey ? "Sending..." : "Renew"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>

      <tfoot>
        <tr>
          <td colSpan={6}>
            <Pagination page={page} totalPages={totalPages} onGoToPage={onGoToPage} />
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
